export default "__VITE_ASSET__B0TUy4Q0__"